import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import waiverReducer from './waiverSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    waiver: waiverReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
